import React from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { getColorOptions, getColorPaletteSettings } from './CellFormatingHelper';
import { ColorPicker } from '@progress/kendo-react-inputs';
import { useTranslation } from 'react-i18next';

const Statement = ({
    label,
    color,
    onColorChange,
    colorOption,
    onColorOptionChange,
    removeTitle,
    onRemove,
}) => {

    const { t } = useTranslation([
        "attribute/cell_formatting"
    ]);

    const paletteSettings = getColorPaletteSettings();
    const colorOptions = getColorOptions();

    const translatedColorOptions = colorOptions.map(option => {
        return {
            text: t("color_options." + option.trim().toLowerCase().replace(/ /g, "_")),
            value: option
        };
    });

    function getTranslatedColorOptionValue() {
        if (typeof colorOption === "object") {
            return {
                text: t("color_options." + colorOption.value.trim().toLowerCase().replace(/ /g, "_")),
                value: colorOption.value
            };
        }
        return {
            text: t("color_options." + colorOption.trim().toLowerCase().replace(/ /g, "_")),
            value: colorOption
        };
    }

    return (
        <div className="row mt-3">
            <div className="col-3">
                <label className="col-form-label">{label}</label>
            </div>
            <div className="col-4">
                <DropDownList
                    data={translatedColorOptions}
                    value={getTranslatedColorOptionValue()}
                    textField="text"
                    onChange={(e) => onColorOptionChange(e.target.value)}
                />
            </div>
            <div className="col-1">
                <label className="col-form-label">
                    {t("to_statement")}
                </label>
            </div>
            <div className="col-2">
                <ColorPicker
                    paletteSettings={paletteSettings}
                    size="medium"
                    value={color}
                    format="hex"
                    onChange={(e) => onColorChange(e.value)}
                />
            </div>
            <div className="col-1">
                <i
                    title={removeTitle}
                    onClick={onRemove}
                    className="fas fa-times text-danger cursor-pointer mt-2 font-size-3"
                ></i>
            </div>
        </div>
    );
};

export default Statement;